import React, { ChangeEvent, useState , useEffect } from "react";
import classNames from "classnames";
import { GroupContext } from "./Group";
import { ConfigContext } from "../config-provider";
import "./style.scss";


export interface IOnCheckboxChange {
  target: {
    checked: boolean;
    value: string;
  };
}

export interface ICheckboxProps {
  prefixCls?: string;
  className?: string;
  onChange?: (e: IOnCheckboxChange) => void;
  disabled?: boolean;
  defaultChecked?: boolean;
  value?: string | number;
  checked?: boolean | null;
}

interface IState {
  checked: boolean;
}

const Checkbox: React.FC<ICheckboxProps> = props => {
  const {
    prefixCls = "rc-checkbox",
    className,
    onChange,
    defaultChecked = false,
    disabled = false,
    children,
    value,
    ...rest
  } = props;

  const checked = "checked" in props ? props.checked : defaultChecked;

  const [state, setState] = useState<IState>({
    checked,
  });

  const classString = classNames(
    prefixCls,
    {
      [`${prefixCls}-disabled`]: disabled,
    },
    className,
  );

  const inputCls = classNames(`${prefixCls}-input`, {
    [`${prefixCls}-input-disabled`]: disabled,
  });

  const innerCls = classNames(`${prefixCls}-inner`, {
    [`${prefixCls}-inner-checked`]: state.checked,
    [`${prefixCls}-inner-disabled`]: disabled,
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (disabled) {
      return;
    }

    if (!("checked" in props)) {
      setState({
        checked: e.target.checked,
      });
    }

    if (onChange) {
      onChange({
        target: {
          checked: e.target.checked,
          value: e.target.value,
        },
      });
    }
  };

  return (
    <label className={classString}>
      <span>
        <input
          className={inputCls}
          type="checkbox"
          onChange={handleChange}
          checked={state.checked}
          disabled={disabled}
          value={value || null}
        />
        <span className={innerCls} />
      </span>

      {children !== undefined && <span className="rc-checkbox-content">{children}</span>}
    </label>
  );
};

export default Checkbox;
